import React from "react";
import { Modal, Divider } from "antd";
import "./modalstyles.css";

const MaintenanceModal = ({ visible, onClose }) => {
  const modalContentStyle = {
    fontSize: "16px",
    overflowY: "auto",
    maxHeight: "60vh",
    scrollbarWidth: "thin",
  };

  return (
    <Modal
      title="Scheduled Maintenance Notification"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      className="maintenance-modal"
      bodyStyle={modalContentStyle}
      maskClosable={false}
    >
      <div className="modal-content">
        <Divider className="modal-divider" />
        <p className="modal-paragraph">
          <span className="strong-style">Dear valued Trainery One users,</span>
        </p>
        <p className="modal-paragraph">
          We want to ensure the continued reliability and security of our
          services. To achieve this, we will be performing scheduled maintenance
          activities on our platform.
        </p>
        <Divider className="modal-divider" />
        <p className="modal-paragraph">
          <span className="strong-style">Maintenance Schedule :</span>
        </p>
        <ul className="modal-list">
          <li>
            Date : <span style={{ fontWeight: "500" }}>28-April-2024 </span>
          </li>
          <li>
            Time : <span style={{ fontWeight: "500" }}>22:00 Hrs (EDT)</span>
          </li>
        </ul>

        <p className="modal-paragraph">
          During this period, Trainery One will be temporarily unavailable,
          including access to your account. We apologize for any inconvenience
          this may cause and thank you for your understanding as we work to
          improve your experience.
        </p>
        <Divider className="modal-divider" />
        <p className="modal-paragraph">
          <span className="strong-style">Please note the following :</span>
        </p>
        <ul className="modal-list">
          <li>
            <span style={{ fontWeight: "500" }}>No data loss </span>: Your data
            and account information will remain safe and intact during this
            maintenance.
          </li>
          <li>
            <span style={{ fontWeight: "500" }}>Duration </span>: We anticipate
            the maintenance to last approximately{" "}
            <span style={{ fontWeight: "500" }}>8</span> (Eight) hours. We will
            do our best to complete it as quickly as possible.
          </li>
        </ul>
        <Divider className="modal-divider" />
        <p className="modal-paragraph">
          Thank you for your patience and continued support. If you have any
          urgent concerns or questions, please feel free to contact our customer
          support team at{" "}
          <a href="mailto:support@trainery.one">support@trainery.one</a>.
        </p>
        <Divider className="modal-divider" />
        <p className="modal-paragraph">
          We appreciate your trust in Trainery One and look forward to providing
          you with an even better experience after the maintenance is complete.
        </p>
      </div>
    </Modal>
  );
};

export default MaintenanceModal;
